import { makeActionCreator } from '../../config/store/utils'
import { getAllProviders } from '../../services/search'

export const GET_BUYERS_ITEMS_AND_PRODUCTS = 'GET_BUYERS_ITEMS_AND_PRODUCTS'
export const GET_BUYERS_ITEMS_AND_PRODUCTS_ERROR = 'GET_BUYERS_ITEMS_AND_PRODUCTS_ERROR'
export const GET_BUYERS_ITEMS_AND_PRODUCTS_SUCCESS = 'GET_BUYERS_ITEMS_AND_PRODUCTS_SUCCESS'
export const onGetBuyersItemsAndProducts = makeActionCreator(GET_BUYERS_ITEMS_AND_PRODUCTS)
export const onGetBuyersItemsAndProductsError = makeActionCreator(GET_BUYERS_ITEMS_AND_PRODUCTS_ERROR, 'payload')
export const onGetBuyersItemsAndProductsSuccess = makeActionCreator(GET_BUYERS_ITEMS_AND_PRODUCTS_SUCCESS, 'payload')
export const onGetBuyersItemsAndProductsThunk = () => async dispatch => {
  dispatch(onGetBuyersItemsAndProducts())

  try {
    const response = await getAllProviders()
    if (response.status !== 200) {
      return dispatch(onGetBuyersItemsAndProductsError(response.data.errores))
    }

    const csvStructure = response.data.map(entity => [entity.name, entity.sector, entity.entcode])

    return dispatch(onGetBuyersItemsAndProductsSuccess({ buyers: csvStructure }))
  } catch (error) {
    return dispatch(onGetBuyersItemsAndProductsError(error))
  }
}
